// File: cgp-user-profile-dialog-module.ts
// Author: James L Seebach
// Date: 5/12/2017
// Desc: CGP User Profile module.
// Other Contributors:

import { NgModule } from '@angular/core';

import { CgpUserProfileDialogComponent } from "./cgp-user-profile-dialog.component";
import { CgpUserProfileDialogService } from "./cgp-user-profile-dialog.service";
import { PipesModule } from '../pipes/pipes.module';
import { CommonModule } from '@angular/common';
import { UserProfileService } from '../../components/ve/ve.service';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyChipsModule as MatChipsModule } from '@angular/material/legacy-chips';

@NgModule({
    imports: [
        MatDialogModule,
        MatButtonModule,
        MatChipsModule,
        CommonModule,
        PipesModule
    ],
    exports: [
        CgpUserProfileDialogComponent
    ],
    declarations: [
        CgpUserProfileDialogComponent
    ],
    providers: [
        CgpUserProfileDialogService, UserProfileService
    ]
})
export class CgpUserProfileDialogModule { }
